import PropTypes from 'prop-types';

const { string, bool, shape } = PropTypes;

export const AddRoomPropTypes = {
  roomName: string,
  roomNamePlaceholder: string,
  roomError: bool,
  roomLength: string,
  roomLengthPlaceholder: string,
  lengthError: bool,
  roomWidth: string,
  roomWidthPlaceholder: string,
  widthError: bool,
  styleHelper: bool,
  isEdit: bool,
  showModal: PropTypes.bool,
  updatedMeasure: shape({
    id: string,
    room: string,
    length: string,
    width: string,
  }),

};

export const defaultAddRoomPropTypes = {
  roomName: '',
  roomNamePlaceholder: '',
  roomError: false,
  roomLength: '',
  roomLengthPlaceholder: '',
  lengthError: false,
  roomWidth: '',
  roomWidthPlaceholder: '',
  widthError: false,
  styleHelper: false,
  isEdit: false,
  showModal: false,
  updatedMeasure: {
    id: '',
    room: '',
    length: '',
    width: '',
  },
};
